module.exports = __webpack_public_path__ + "static/accreditations1-5194249005ccaed81b6449b30740fb69.png";